import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteBgCurves = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 374.999, height: 43.27, preserveAspectRatio: "none", viewBox: "0 0 374.999 43.27", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M524 571.794h375v14.117c-25.368 13.435-50.7 23.427-76 25.388-33.036 2.727-65.908-8.226-98.741-19.181C688.509 580.192 652.808 568.266 617 574c-30.825 4.986-61.857 22.919-93 41.063z", transform: "rotate(180 449.499 307.532)", fill: "#fff" }));
const ForwardRef = forwardRef(SvgWhiteBgCurves);
export { ForwardRef as ReactComponent };
